import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration';

/**
 * @function ClearCacheLogout
 * @description React component that clears the cache, localStorage, and sessionStorage, then redirects to the organization selection page.
 * @returns {JSX.Element} A div indicating that the logout and cache clearing process is in progress.
 */
const ClearCacheLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      // Clear caches
      if ('caches' in window) {
        /** @type {string[]} */
        const cacheNames = await caches?.keys();
        await Promise.all(cacheNames?.map((cache) => caches?.delete(cache)));
      }

      // Clear localStorage, sessionStorage, and redirect
      localStorage.clear();
      sessionStorage.clear();

      /**
       * Update the service worker to ensure the latest version of the app is used.
       */
      serviceWorkerRegistration.updateServiceWorker();
      console.log('Cache cleared!');
      navigate('/org');
    })();
  }, [navigate]);

  return <div>Logging out and clearing cache...</div>;
};

export default ClearCacheLogout;
